const CryptoJS = require('crypto-js'); //引用AES源码js

const key = CryptoJS.enc.Utf8.parse('kijjghdsjhf23456'); //密钥

export function encrypt(word) {
	//加密
	let srcs = CryptoJS.enc.Utf8.parse(word);
	let encrypted = CryptoJS.AES.encrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		pad: CryptoJS.pad.Pkcs5
	});
	return encrypted.toString();
}
export function decrypt(word) {
	//解密
	let decrypt = CryptoJS.AES.decrypt(word, key, {
		mode: CryptoJS.mode.ECB,
		pad: CryptoJS.pad.PKCS5Padding
	});
	let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
	return decryptedStr.toString();
}